import React, { Component } from "react";
import settings from './file/settings.png';
import plugin from './file/plugin.png';
import lockgreen from './file/lockgreen.png';

import { Helmet } from "react-helmet";

class HowItWorks extends Component {
    render() {

        let pageTitle = this.props.lang == 'en' ? "How it Works" : "Πως δουλευει";
        let webplugin = this.props.lang == 'en' ? "Web Plugin" : "Επεκταση Φυλλομετρητη";
        let usercontrol = this.props.lang == 'en' ? "User Control" : "Ελεγχος απο το χρηστη";
        let customizedsett = this.props.lang == 'en' ? "Customized Settings" : "Προσαρμοσμενες Ρυθμισεις";
        let closewindow = this.props.lang == 'en' ? "Close Window" : "Κλείσιμο Παραθύρου";
        let webplugingText = this.props.lang == 'en' ? "The PrivacySaferII extension is compatible with Google Chrome, Mozilla Firefox and the latest version of Micosoft Edge browsers"
            : "Η επέκταση PrivacySaferII είναι συμβατή με τους φυλλομετρτητές Google Chrome, Mozilla Firefox και την τελευταία έκδοση του Microsoft Edge."
        let usercontrolText = this.props.lang == 'en' ? "PrivacySaferII extension gives you the opportunity to set which data isaccessible and which is hidden from a web application."
            : "Η επέκταση PrivacySaferII σας δίνει την ευκαιρία να ορίσετε ποια δεδομένα είναι προσβάσιμα και ποια είναι κρυμμένα από μια εφαρμογή ιστού (ιστοσελίδα). "
        let customizedsettText = this.props.lang == 'en' ? "PrivacySaferII extension provides the ability to set Customized settings. You can allow different access to a specific page or a group of pages, on specific days and times."
            : "Η επέκταση PrivacySaferII παρέχει τη δυνατότητα ορισμού προσαρμοσμένων ρυθμίσεων. Μπορείτε να επιτρέψετε διαφορετική πρόσβαση σε μια συγκεκριμένη σελίδα ή μια ομάδα σελίδων, σε συγκεκριμένες ημέρες και ώρες."

        return (
            <div>
                <Helmet>
                    <meta charset="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <meta name="description" content="" />
                    <meta name="author" content="" />
                    <title>PrivacySaferIII</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
                    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
                    <script src="https://use.fontawesome.com/releases/v5.12.1/js/all.js" crossorigin="anonymous"></script>

                    <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
                    <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet"
                        type="text/css" />
                </Helmet>
                <section className="page-section portfolio" id="portfolio">
                    <div className="container">

                        <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0"><label className="lang"
                            key="howitworksTitle">{pageTitle}</label></h2>

                        <div className="divider-custom">
                            <div className="divider-custom-line"></div>
                            <div className="divider-custom-icon"><i className="fas fa-book"></i></div>
                            <div className="divider-custom-line"></div>
                        </div>

                        <div className="row">
                            <h2 className="portfolio-modal-title text-secondary text-uppercase mb-0"><label className="lang"
                                key="webpluging"> {webplugin}</label></h2>
                            <br>
                            </br>

                        </div>
                        <div className="row">
                            <div className="col-md-3 col-xs-4 mb-5">
                                <img className="img-fluid" src={plugin} alt="" />
                            </div>
                            <div className="col-md-9 col-lg-4 mb-5">
                                <p className="mb-5"><label className="lang" key="webplugingText"> {webplugingText}</label> </p>
                            </div>

                        </div>

                        <div className="row">

                            <h2 className="portfolio-modal-title text-secondary text-uppercase mb-0"><label className="lang"
                                key="usercontrol"> {usercontrol}</label> </h2>
                        </div>

                        <div className="row">
                            <div className="col-md-3 col-xs-4 mb-5">
                                <img className="img-fluid" src={lockgreen} alt="" />
                            </div>
                            <div className="col-md-9 col-lg-4 mb-5">
                                <p className="mb-5"><label className="lang" key="webplugingText"> {usercontrolText}</label> </p>
                            </div>

                        </div>

                        <div className="row">

                            <h2 className="portfolio-modal-title text-secondary text-uppercase mb-0"><label className="lang"
                                key="customizedsett"> {customizedsett}</label></h2>
                        </div>

                        <div className="row">
                            <div className="col-md-3 col-xs-4 mb-5">
                                <img className="img-fluid" src={settings} alt="" />
                            </div>
                            <div className="col-md-9 col-lg-4 mb-5">
                                <p className="mb-5"><label className="lang" key="webplugingText"> {customizedsettText}</label> </p>
                            </div>

                        </div>

                    </div>

                </section>







            </div>


        );

    }
}

export default HowItWorks;